<template>
    <div>
        <div v-if="user.newUserOrders && user.newUserOrders.length > 0">
            <div class="box-shadow pl-0 pr-0 order-table">
                <div class="title-4 text-uppercase color-primary mb-24 pl-20">Новые заказы</div>
                <div class="order-table__header">
                    <div>№</div>
                    <div>Срок аренды</div>
                    <div>Номер заказа</div>
                    <div>Статус</div>
                </div>
                <div  class="order-table__body" role="tablist">
                    <div v-for="(item, i) in user.newUserOrders" :key="i">
                        <account-item :item="item" :i="i" :code="user.userData.code" :user="user.userData.code"></account-item>
                    </div>
                </div>

                <div v-if="user.userOrders && user.userOrders.length > 0" class="pl-20 font-500 pt-3">
                    <router-link to="/account/orders" class="link-catalog">Смотреть все заказы</router-link>
                </div>
            </div>
        </div>

        <div v-else class="d-block d-lg-none">
            <p class="mb-1">У Вас нет заказов в данном разделе.</p>
            <p>Перейдите в
                <router-link class="color-primary" to="/catalog">каталог</router-link>
                и выберите необходимые для вас товары.
            </p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            },
        },

        mounted() {
        }
    }
</script>
